import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()

export class NavigationService {
  constructor(private router: Router) {

  }

  // goToDashboard() {
  //   this.router.navigate(['/product']);
  // }
  goToRealTimeTracking() {
    this.router.navigate(['/realtimetracking']);
  }
  goToMhireDashboard() {
    this.router.navigate(['/mhiredashboard']);
  }
  goToLogin() {
    // this.router.navigate(['/login']);
    this.router.navigate(['/auth/login']);
  }

  goToUnAuthorized() {
    this.router.navigate(['/unauthorized']);
  }

  goToSessionTimedOut() {
    this.router.navigate(['/sessiontimedout']);
  }

  isOnLoginScreen(): boolean {
    return this.router.url === '/login';
  }

  goToLiveTrack(id: number) {
    this.router.navigate(['/livetrack/' + id]);
  }
  goToLiveCharts(id: number) {
    this.router.navigate(['/realtimecharts/' + id]);
  }
  goToLiveTrackOverview() {
    this.router.navigate(['/livetrack']);
  }

  goToVehicle(id: number, actionInfo: number) {
    this.router.navigate(['/vehicles/' + id, actionInfo]);
  }

  goToDriver(id: number, actionInfo: number) {
    this.router.navigate(['/drivers/' + id, actionInfo]);
  }
  goToFuelLog(id: number, actionInfo: number) {
    this.router.navigate(['/fuellog/' + id, actionInfo]);
  }

  goToFarmerEntries(id: number, actionInfo: number) {
    this.router.navigate(['/farmerentries/' + id, actionInfo]);
  }

  goToUser(id: number, actionInfo: number) {
    this.router.navigate(['/user/' + id, actionInfo]);
  }
  goToProfile(id: number, actionInfo: number) {
    this.router.navigate(['/profile/' + id, actionInfo]);
  }
  goToVehicleGroup(id: number, actionInfo: number) {
    this.router.navigate(['/vehiclegroups/' + id, actionInfo]);
  }

  goToServiceSchedule(id: number, actionInfo: number) {
    this.router.navigate(['/serviceschedules/' + id, actionInfo]);
  }

  goToInsurance(id) {
    this.router.navigate(['/insurancepopup/' + id]);
  }
  goToServiceLog(id: number, actionInfo: number, pagetype: string, status: number) {
    this.router.navigate(['/servicelog/' + id, actionInfo, pagetype, status]);
  }
  goToDevice(id: number, actionInfo: number) {
    this.router.navigate(['/devices/' + id, actionInfo]);
  }
  goToProvider(id: number, actionInfo: number) {
    this.router.navigate(['/providers/' + id, actionInfo]);
  }
  goToTripsimulation(data: any) {
    this.router.navigate(['/tripsimulationreport/' + data]);
  }
  goToDistrict(id: number, actionInfo: number, data:any) {
    this.router.navigate(['/supplier/' + id, actionInfo, data]);
  }
  gotosuplierview(id: number, actionInfo: number){
    this.router.navigate(['/supplier/' + id, actionInfo ])
  }
  gotoproduct(){
    this.router.navigate(['/supplier/' ])
  }
  gotoCustomerAdd(id: number, actionInfo: number){
    this.router.navigate(['/customer/'+ id, actionInfo, ])
  }
  gotoCustomer(){
    this.router.navigate(['/customer/' ])
  }
  gotoCustomerview(id: number, actionInfo: number){
    this.router.navigate(['/customer/' + id, actionInfo, ])
  }
  goToBlock(id: number, actionInfo: number) {
    this.router.navigate(['/block/' + id, actionInfo]);
  }
  goToVillage(id: number, actionInfo: number) {
    this.router.navigate(['/village/' + id, actionInfo]);
  }
  goToCashBooking() {
    this.router.navigate(['/cashbooking/']);
  }
  goToNewCashBooking(id: number, actionInfo: number) {
    this.router.navigate(['/cashbooking/' + id, actionInfo]);
  }
  goToViewCashBooking(id: number) {
    this.router.navigate(['/cashbooking/' + id]);
  }
  goToWorkshops(id: number, actionInfo: number) {
    this.router.navigate(['/workshops/' + id, actionInfo]);
  }
  goToImplement(id: number, actionInfo: number) {
    this.router.navigate(['/implements/' + id, actionInfo]);
  }
  goToTarrif(id: number, actionInfo: number) {
    this.router.navigate(['/tariffs/' + id, actionInfo]);
  }
  goToTripEntry(id: number, actionInfo: number, approveTrue: boolean, pageType: number) {
    this.router.navigate(['/tripentries/' + id, actionInfo, approveTrue, pageType]);
  }
  goToTarget(id: number, actionInfo: number, pageType: number) {
    this.router.navigate(['/targets/' + id, actionInfo, pageType]);
  }
  goToexpenseLogs(id: number, actionInfo: number) {
    this.router.navigate(['/expenselogs/' + id, actionInfo]);
  }


  goToEditUser(id) {
    this.router.navigate(['/product/'+id]);
}


}


